import React from 'react';
import { Download, FileSpreadsheet, Plus, Upload } from 'lucide-react';
import { GuestFilterBar } from './GuestFilterBar';
import { GuestRow } from './GuestRow';

export const GuestTable = ({
  guests,
  searchTerm,
  setSearchTerm,
  selectedTagFilter,
  setSelectedTagFilter,
  selectedRsvpFilter,
  setSelectedRsvpFilter,
  rsvpFilters,
  filteredGuests,
  modifiedGuests,
  allTags,
  onAddGuest,
  onExportGuests,
  onImportGuests,
  onDownloadGuestTemplate,
  guestImportStatus,
  ...actions
}) => (
  <div className="bg-white rounded-[40px] shadow-2xl border border-white overflow-hidden">
    <div className="flex flex-col gap-4 border-b border-gray-50 p-6 md:flex-row md:items-center md:justify-between md:px-8">
      <div>
        <p className="text-[10px] font-black uppercase tracking-[0.22em] text-[#b07c98]">Guest List</p>
        <h2 className="mt-1 text-2xl font-black text-gray-950">Review invitees</h2>
        {guestImportStatus ? (
          <p className="mt-2 text-xs font-bold text-[#9b4775]">{guestImportStatus}</p>
        ) : null}
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onDownloadGuestTemplate}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-gray-100 px-4 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-gray-600 transition hover:bg-gray-950 hover:text-white"
        >
          <FileSpreadsheet size={14} /> Template
        </button>
        <button
          type="button"
          onClick={onImportGuests}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#fff1f8] px-4 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-[#a52b69] transition hover:bg-[#ff0099] hover:text-white"
        >
          <Upload size={14} /> Import CSV
        </button>
        <button
          type="button"
          onClick={onExportGuests}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#f3fff8] px-4 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-emerald-700 transition hover:bg-emerald-600 hover:text-white"
        >
          <Download size={14} /> Export CSV
        </button>
        <button
          type="button"
          onClick={onAddGuest}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-gray-950 px-5 py-3 text-xs font-black uppercase tracking-[0.18em] text-white transition hover:bg-[#ff0099]"
        >
          <Plus size={15} /> Add Guest
        </button>
      </div>
    </div>
    <GuestFilterBar 
      guests={guests} 
      searchTerm={searchTerm} 
      setSearchTerm={setSearchTerm}
      selectedTagFilter={selectedTagFilter} 
      setSelectedTagFilter={setSelectedTagFilter}
      selectedRsvpFilter={selectedRsvpFilter}
      setSelectedRsvpFilter={setSelectedRsvpFilter}
      rsvpFilters={rsvpFilters}
      allTags={allTags}
    />
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead className="bg-gray-50/50 text-[10px] font-black text-gray-400 uppercase tracking-widest">
          <tr>
            <th className="px-8 py-5">Guest Information</th>
            <th className="px-8 py-5">RSVP</th>
            <th className="px-8 py-5">Group</th>
            <th className="px-8 py-5">Experience</th>
            <th className="px-8 py-5 text-right">Settings</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {filteredGuests.map((g) => (
            <GuestRow 
              key={g.guest.id} 
              guest={g} 
              modified={modifiedGuests.has(g.guest.id)} 
              {...actions} 
            />
          ))}
          {filteredGuests.length === 0 && (
            <tr>
              <td colSpan="5" className="px-8 py-12 text-center">
                <p className="text-sm font-black text-gray-700">No guests found yet.</p>
                <p className="mt-2 text-xs font-semibold text-gray-400">
                  Add your first guest to start the simple invite flow.
                </p>
                <button
                  type="button"
                  onClick={onAddGuest}
                  className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-[#ff0099] px-5 py-3 text-xs font-black uppercase tracking-[0.18em] text-white transition hover:bg-gray-950"
                >
                  <Plus size={15} /> Add Guest
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);
